module.exports = __webpack_public_path__ + "static/img/数字影像@3x.094b220.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index/数字影像@3x.png
// module id = 794
// module chunks = 382